module.exports = __webpack_public_path__ + "assets/img/logo2.9a5ec399.png";